import { addRtkQueryBridges, buildSlice, CommonState } from '~libs/reduxUtils';
import { Appointment, AssignableUser } from '~weekly-planner/lib/common';

import { appointmentsApi, typePrefix } from '~weekly-planner/actions/appointments';

interface State extends CommonState<Appointment> {
  assignableUsers: Array<AssignableUser>;
  exceptions: { rescheduled: []; cancelled: [] };
  onHold: [];
  changes: any[];
  loadingStates: {
    assignableUsers: string;
    exceptions: string;
    onHold: string;
    changes: string;
  };
}

const initialState: State = {
  loading: 'idle',
  error: null,
  rows: [],

  assignableUsers: [],
  exceptions: { rescheduled: [], cancelled: [] },
  onHold: [],
  changes: [],

  loadingStates: {
    assignableUsers: 'idle',
    exceptions: 'idle',
    onHold: 'idle',
    changes: 'idle',
  },
};

const slice = buildSlice<State, Appointment>(typePrefix, initialState, {
  extraReducers: (builder) => {
    addRtkQueryBridges<State, Appointment>(builder, [
      {
        endpoint: appointmentsApi.endpoints.getAppointments,
        mode: 'list',
        selectRows: (payload: Appointment[]) => payload,
      },
      {
        endpoint: appointmentsApi.endpoints.getAssignableUsers,
        mode: 'list',
        apply: (state, payload) => {
          state.assignableUsers = payload as AssignableUser[];
          state.loadingStates.assignableUsers = 'fulfilled';
        },
        onPending: (state) => {
          state.loadingStates.assignableUsers = 'pending';
          state.assignableUsers = [];
        },
        onRejected: (state) => {
          state.loadingStates.assignableUsers = 'declined';
        },
      },
      {
        endpoint: appointmentsApi.endpoints.getOnHold,
        mode: 'list',
        apply: (state, payload) => {
          state.onHold = payload as any;
          state.loadingStates.onHold = 'fulfilled';
        },
        onPending: (state) => {
          state.loadingStates.onHold = 'pending';
          state.onHold = [];
        },
        onRejected: (state) => {
          state.loadingStates.onHold = 'declined';
        },
      },
      {
        endpoint: appointmentsApi.endpoints.getExceptions,
        mode: 'list',
        apply: (state, payload) => {
          state.exceptions = payload as any;
          state.loadingStates.exceptions = 'fulfilled';
        },
        onPending: (state) => {
          state.loadingStates.exceptions = 'pending';
          state.exceptions = { rescheduled: [], cancelled: [] };
        },
        onRejected: (state) => {
          state.loadingStates.exceptions = 'declined';
        },
      },
      {
        endpoint: appointmentsApi.endpoints.getBuiltChanges,
        mode: 'list',
        apply: (state, payload) => {
          state.changes = payload as any[];
          state.loadingStates.changes = 'fulfilled';
        },
        onPending: (state) => {
          state.loadingStates.changes = 'pending';
          state.changes = [];
        },
        onRejected: (state) => {
          state.loadingStates.changes = 'declined';
        },
      },
    ]);
  },
});

export const { clear, updateParams } = slice.actions;

export default slice.reducer;
